{
    "codes": [
        {
            "namespace": "QuantityCartRule",
            "errorcode": 9,
            "displayMessage": "Sie haben bereits die maximale Anzahl im Warenkorb.",
            "displayClass": "info"
        },
        {
            "namespace": "shoppingCart-service",
            "errorcode": 7,
            "displayMessage": "Sie haben bereits die maximale Anzahl im Warenkorb.",
            "displayClass": "info"
        },
        {
            "namespace": "shoppingCart-service",
            "errorcode": 6,
            "displayMessage": "Der Preis des Artikels hat sich geändert.",
            "displayClass": "info"
        },
        {
            "namespace": "shoppingCart-service",
            "errorcode": 14,
            "displayMessage": "Es konnte kein aktueller Preis für den Artikel gefunden werden.",
            "displayClass": "error"
        },
        {
            "namespace": "order-service",
            "errorcode": 7,
            "displayMessage": "Der Preis des Artikels hat sich geändert.",
            "displayClass": "info"
        },
        {
            "namespace": "order-service",
            "errorcode": 8,
            "displayMessage": "Der Artikel ist nicht mehr verfügbar.",
            "displayClass": "error"
        },
        {
            "namespace": "order-service",
            "errorcode": 9,
            "displayMessage": "Sie haben bereits die maximale Anzahl im Warenkorb.",
            "displayClass": "info"
        },
        {
            "namespace": "order-service",
            "errorcode": 10,
            "displayMessage": "Anzahl wurde im Warenkorb angepasst.",
            "displayClass": "info"
        },
        {
            "namespace": "ValidationResult",
            "errorcode": 1001,
            "displayMessage": "Es gibt Probleme im Warenkorb und der Artikel konnte nicht hinzu gelegt werden.",
            "displayClass": "error"
        },
        {
            "namespace": "wishlist",
            "errorcode": 1,
            "displayMessage": "Der Artikel konnte nicht hinzugefügt werden.",
            "displayClass": "error"
        },
        {
            "namespace": "wishlist",
            "errorcode": 2,
            "displayMessage": "Der Artikel konnte nicht extrahiert werden.",
            "displayClass": "error"
        },
        {
            "namespace": "reservation",
            "errorcode": 100,
            "displayMessage": "Es muss mindenstens ein Artikel im Warenkorb liegen.",
            "displayClass": "error"
        },
        {
            "namespace": "reservation",
            "errorcode": 101,
            "displayMessage": "Bitte wählen Sie zuerst einen Fachmarkt aus in welchem Sie Artikel reservieren möchten.",
            "displayClass": "error"
        },
        {
            "namespace": "reservation",
            "errorcode": 103,
            "displayMessage": "Leider ist Ihre eingegebene Adresse nicht gültig.",
            "displayClass": "error"
        },
        {
            "namespace": "reservation",
            "errorcode": 104,
            "displayMessage": "Ein Preis hat sich geändert.",
            "displayClass": "info"
        },
        {
            "namespace": "Captcha",
            "errorcode": 10,
            "displayMessage": "Es muss ein Captcha eingegeben werden.",
            "displayClass": "info"
        },
        {
            "namespace": "Push",
            "errorcode": 1,
            "displayMessage": "Die Berechtigungen um Push-Benachrichtigungen zu empfangen fehlen.",
            "displayClass": "error"
        }
    ]
}